module.exports = __webpack_public_path__ + "media/40.1d553251.wav";